import http from "@/utils/http";

export async function signup(data) {
  const req = (await http.post('/auth/signup', data));

  return req.data;
}

export async function verify_email(data) {
  const req = (await http.post('/auth/verify-email', data));

  return req.data;
}

export async function resend_otp(data) {
  // URL-encode email to handle special characters like +
  const req = (await http.get(`/auth/resend-email-verification/${encodeURIComponent(data)}`));

  return req.data;
}

export async function login(data) {
  const req = (await http.post('/auth/login', data));

  return req.data;
}

export async function logout() {
  const req = (await http.get('/auth/logout'));

  return req.data;
}

export async function password_reset_link(data) {
  const req = (await http.post('/auth/reset-password', data));
  return req.data;
}

export async function reset_password(data) {
  // Use v2 endpoint that accepts email in body to avoid URL encoding issues with special characters like +
  const req = (await http.post(`/auth/reset-password-v2/${data.token}`, { email: data.email, newPassword: data.newPassword }));
  return req.data;
}

export async function signup_via_invite(data) {
  // Use v2 endpoint that accepts email in body to avoid URL encoding issues with special characters like +
  const req = (await http.post(`/auth/signup-via-invite-v2/${data.token}`, {
 email: data.email, first_name: data.first_name, last_name: data.last_name, phone_number: data.phone_number, newPassword: data.password
}));
  return req.data;
}

export async function user_details() {
  const req = (await http.get(`/user`));

  return req.data;
}

export async function get_current_user_permissions() {
  try {
    console.log('🔍 Calling permissions API: /user/permissions/current')
    const response = await http.get(`/user/permissions/current`);
    console.log('✅ Permissions API response:', response)
    console.log('✅ Permissions data:', response.data)
    // Backend returns {statusCode, message, data: permissions}
    // axios wraps it, so response.data is {statusCode, message, data: permissions}
    return response.data;
  } catch (error) {
    // Return default permissions if API fails
    return {
      data: null,
      error,
    };
  }
}

export async function getUserDraft(userId) {
  const req = (await http.get(`/user/user-draft/${userId}`));

  return req.data;
}

export async function updateUserDraft(userId, data) {
  const req = (await http.put(`/user/user-draft/${userId}`, data));

  return req.data;
}

export async function updateTokenByRole(data) {
  const req = (await http.post('/auth/role', data));

  return req.data;
}
